type PageItem = number | "...";

/*
 * getPageNumbers function
 * Returns an array of page numbers for a pagination component.
 */
export const getPageNumbers = (currentPage: number, totalPages: number) => {
  // Early return for small number of pages
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  // Helper to create range of numbers
  const range = (start: number, end: number): number[] => Array.from({ length: end - start + 1 }, (_, i) => start + i);

  // Always show first and last page
  const pages: PageItem[] = [1];

  // Calculate middle range
  if (currentPage <= 4) {
    // Near start: show 1,2,3,4,5,...,totalPages
    pages.push(...range(2, 5));
    pages.push("...", totalPages);
  } else if (currentPage >= totalPages - 3) {
    // Near end: show 1,...,96,97,98,99,100
    pages.push("...", ...range(totalPages - 4, totalPages));
  } else {
    // Middle: show 1,...,6,7,8,...,100
    pages.push("...", ...range(currentPage - 1, currentPage + 1), "...", totalPages);
  }

  return pages;
};
